import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUnauthedBusiness from "../fragments/fullUnauthedBusinessV4"

const query = gql`
  query BussinessBySubdomain($subdomain: String!) {
    businessBySubdomain(subdomain: $subdomain) {
      ...fullUnauthedBusiness
    }
  }
  ${fullUnauthedBusiness}
`

export const businessBySubdomainKey = getQueryNames(query)[0]

export default query
